import { render, staticRenderFns } from "./RelatorioRecebimento.vue?vue&type=template&id=241a2e2e&"
import script from "./RelatorioRecebimento.vue?vue&type=script&lang=js&"
export * from "./RelatorioRecebimento.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioRecebimento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports